import { IFileFieldValue } from '../types/file';
import { fileSizeFormatter } from '../formatters';
import { IPhotoFile } from '../../../AreaParts/internal/components/AreaPart/internal/components/Photo/types';

export const mapDocumentToFieldValue = (document: IPhotoFile): IFileFieldValue => {
  return {
    name: document.name,
    id: document.id,
    size: fileSizeFormatter(document.size),
    preview: document.preview,
    rotateDegree: document.rotateDegree,
  };
};
